<template>
    <div class="wrp">
      <div class="xy-tid">Predict AI Service Agreement</div>
      <div class="cont">
        <h3>I. Importance of the Service Agreement</h3>
        <span>1.1 Core Content of the Service Agreement</span>
        <p>
          This Agreement is the formal legal document between you and Huiyi Computer regarding the use of its services. It details the rights and obligations of both parties, including but not limited to the scope of services, account security, personal information protection, methods of using the services, and service modification and termination. By agreeing to this Agreement, you acknowledge that you have fully understood and accepted all of its terms.
        </p>
        <span>1.2 Special Notice Clauses</span>
        <p>
          We particularly remind you to pay attention to clauses that may exempt or limit Huiyi Computer's liability, clauses that restrict users' rights, and clauses that specify dispute resolution methods and jurisdiction. These clauses are crucial for protecting the rights of both parties and clarifying the boundaries of liability. We may use bold text, underlines, or other methods to provide special notices, but you still need to read and understand every clause of this Agreement comprehensively and prudently.
        </p>
      </div>
  
      <div class="cont">
        <h3>II. Account and Password Security</h3>
        <span>2.1 Account Registration and Safekeeping</span>
        <p>
          When using Huiyi Computer's services, you may need to register an account. We strongly recommend that you use a strong password and change it regularly to ensure account security. Meanwhile, you should properly safeguard your account and password to avoid account theft or password compromise due to improper safekeeping. You shall bear sole responsibility for any account security issues caused by your personal reasons.
        </p>
        <span>2.2 Account Formats and Associations</span>
        <p>Huiyi Computer accounts may take various forms, including numbers, letters, mobile phone numbers, and email addresses. When you register an account in a certain format, we may provide another presentation form for that account. Please be sure to understand and comply with the relevant account usage rules to ensure the accuracy and security of your account information.</p>
      </div>
  
      <div class="cont">
        <h3>III. Protection of User Personal Information</h3>
        <span>3.1 Information Collection and Use</span>
        <p>
          Huiyi Computer will collect, use, store, and share your personal information in accordance with this Agreement and the "Huiyi Computer Privacy Policy". We are committed to taking all necessary measures to protect your personal information from unauthorized access, use, or disclosure. Meanwhile, we will not transfer or disclose your personal information to any third party unless required by relevant laws and regulations or necessary to provide the services you request.
        </p>
        <span>3.2 Protection of Minors</span>
        <p>If you are a minor, you should obtain the prior consent of your guardian before using Huiyi Computer's services. We attach great importance to the protection of minors' personal information and will strictly handle minors' personal information in accordance with relevant laws and regulations.</p>
      </div>
  
      <div class="cont">
        <h3>IV. Methods of Using the Services</h3>
        <span>4.1 Non-commercial Use</span>
        <p>
          This service is strictly for your personal, non-commercial use. You shall not use this service for any commercial purposes or illegal activities.
        </p>
        <span>4.2 Prohibited Behaviors</span>
        <p>You shall not use any third-party software, plugins, add-ons, or other tools to interfere with, damage, or otherwise affect this service. Meanwhile, you should strictly comply with the Robots protocol and other relevant agreement rules published by Huiyi Computer to ensure that your usage behavior meets all relevant requirements.</p>
      </div>
  
      <div class="cont">
        <h3>V. Service Modification and Termination</h3>
        <span>5.1 Service Modification</span>
        <p>
          Huiyi Computer reserves the right to modify the service content based on adjustments to its business strategy. When modifying the service, we will make every effort to notify you and ensure that your rights and interests are not harmed. However, under certain circumstances, we may not be able to notify you in advance of the specific details of the service modification. Therefore, please regularly check our service announcements and update information.
        </p>
        <span>5.2 Service Termination</span>
        <p>
          In the event of violations of laws and regulations, breaches of this Agreement, or for security reasons, Huiyi Computer reserves the right to suspend or terminate the provision of services to you without prior notice. Meanwhile, if you fail to pay the service fees in full and on time (if applicable), we also reserve the right to suspend, interrupt, or terminate the provision of services. After the service is terminated, we will handle your personal information and data in accordance with relevant laws and regulations.
        </p>
      </div>
  
      <div class="cont">
        <h3>VI. Dispute Resolution and Jurisdiction</h3>
        <span>6.1 Dispute Resolution Methods</span>
        <p>
          If any disputes or controversies arise between you and Huiyi Computer, they should first be resolved through friendly negotiation. If negotiation fails, you may submit the dispute or controversy to a competent People's Court for litigation as stipulated in Article 18 of this Agreement.
        </p>
        <span>6.2 Jurisdiction</span>
        <p>
          This Agreement is signed in Nanshan District, Shenzhen City, Guangdong Province, People's Republic of China. Therefore, the establishment, effectiveness, performance, interpretation, and dispute resolution of this Agreement shall be governed by the laws of Mainland China (excluding conflict of laws). In the event of a dispute, both parties shall comply with the laws and regulations of the People's Republic of China and submit to the jurisdiction of competent courts.
        </p>
      </div>
  
      <div class="cont">
        <h3>VII. Other Important Matters</h3>
        <span>7.1 Terms of Use for Minors</span>
        <p>
          If a user is under the age of 18, they should read this Agreement and use this service under the supervision and guidance of a guardian. Guardians should strengthen guidance and supervision of minors' internet use to ensure the network security and healthy growth of minors.
        </p>
        <span>7.2 Customer Service and Support</span>
        <p>
          If you have any questions or suggestions regarding this Agreement or this service, please feel free to contact our customer service department. We will do our best to provide you with the necessary help and support.
        </p>
      </div>
    </div>
  </template>
    
  <script>
  export default {
    data() {
      return {
        Height: 0,
      };
    },
    created() {},
  
    methods: {},
  };
  </script>
  
  <style scoped>
  .wrp {
    width: 130rem;
    margin: 10.5rem auto 0px;
    text-align: left;
    padding-bottom: 10rem;
  }
  .xy-tid {
    text-align: center;
    padding-top: 10rem;
    font-size: 3.2rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 8rem;
  }
  .cont {
    margin-top: 3rem;
  }
  .cont h3 {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  .cont span {
    margin-left: 3.6rem;
    font-size: 1.6rem;
    font-weight: bold;
  }
  .cont p {
    margin-left: 6.2rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    font-size: 1.6rem;
    text-align: justify;
    text-indent: 2em;
    line-height: 2.5rem;
  }
  
  @media (max-width: 768px) {
    .header {
      display: none;
    }
    .footer {
      display: none;
    }
  }
  </style>